module.exports = __webpack_public_path__ + "static/media/Screenshot_app_4.c390b754.png";